<div class="landing-page">
  <div class="grad-box">
    <div class="flex flex-wrap justify-center h-[calc(100dvh-var(--layout-header-height)-100px)]">
      <div class="w-full lg:w-2/3 content-center text-center pr-4">
        <div class="flex justify-center items-center mb-3">
          <img
            src="/assets/images/offconon.svg"
            class="mr-2 h-8 md:h-10"
            alt="{{ 'OffConOn' | translate }}" />
          <div class="block dark:text-white">
            <span class="text-xl capitalize font-semibold block"> OFFCONON </span>
          </div>
        </div>
        <div
          class="heading-medium mt-4 md:mt-0 animate-duration-500"
          pAnimateOnScroll
          enterClass="animate-zoomin"
          leaveClass="animate-fadeout">
          {{ 'Role-based access control (RBAC)' | translate }}
          <div class="text-red-500">
            {{ 'You do not have access rights to this feature!' | translate }}
          </div>
        </div>
        <div class="paragraph-huge text-gray">
          {{ 'Please contact your system administrators to access this feature.' | translate }}
        </div>

        <div class="flex flex-col justify-center pt-5 md:pt-7 mb-4 lg:mb-0 text-center">
          <p-button
            icon="pi pi-arrow-right"
            iconPos="right"
            label="{{ 'System administrators' | translate }}"
            [rounded]="true"
            (click)="buttonClicked()" />
        </div>
      </div>
    </div>
  </div>
</div>
